import { AdFoxServiceManager } from '../bundles/adfox/adfox_service_manager';
import { sectionBrandingMiddleware } from '../bundles/mainpage/adfox_middlewares/section_branding';

const adfox = new AdFoxServiceManager();
adfox.registerMiddleware('sectionBranding', sectionBrandingMiddleware);

export default adfox;



// WEBPACK FOOTER //
// ./src/di/adfox.ts